<template>
  <div class="users-groups">
    <Body></Body>
    <MainAsideRight :is-open="isOpen" :aside-can-save="canSave" store-path="users">
      <Aside></Aside>
    </MainAsideRight>
  </div>
</template>

<script>
import Aside from './layouts/Aside';
import Body from './layouts/Body';
import MainAsideRight from '@/components/MainAsideRight';
import { mapState, mapActions } from 'vuex';

export default {
  components: { Aside, MainAsideRight, Body },
  computed: {
    ...mapState('users', {
      canSave: s => s.aside.meta.canSave,
      isOpen: s => s.aside.meta.isOpen
    })
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    ...mapActions('users', ['getUsers'])
  }
};
</script>
